<script>

// TODO: pass colors from settings to the script
// TODO: hist lines => recangles (like in volbar.js)

import { Overlay } from '../../'
import { drawIndicatorPlot } from '../../workspace/indicator-plots.mjs'

export default {
    name: 'MACD',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.2',
                desc: 'Moving Average Convergence/Divergence',
                preset: {
                    name: 'MACD $fast $slow $smooth',
                    side: 'offchart',
                    settings: {
                        histWidth: 4,
                        macdWidth: 1,
                        signalWidth: 1,
                        defColor: "#42b28a",
                        macdColor: "#3782f2",
                        signalColor: "#f48709",
                        histColors: [
                            "#35a776", "#79e0b3", "#e54150", "#ea969e"
                        ]
                    }
                }
            }
        },

        draw(ctx) {
            const settings=this.sett;
            const colors=[settings.histRisingPositive||'#26a69a',settings.histFallingPositive||'#b2dfdb',settings.histFallingNegative||'#ff5252',settings.histRisingNegative||'#ffcdd2'];
            const colorForRow=settings.histogramColorMode==='Single'?undefined:row=>colors[row[4]]||colors[0];
            drawIndicatorPlot(ctx,this.data,this.layout,settings,0,{style:'histogram',color:this.color,width:this.hist_width,colorForRow});
            drawIndicatorPlot(ctx,this.data,this.layout,settings,1,{color:this.macd_color,width:this.macd_width});
            drawIndicatorPlot(ctx,this.data,this.layout,settings,2,{color:this.signal_color,width:this.signal_width});

        },
        use_for() { return ['MACD'] },
        legend(values) {
            let xs = values.slice(1,4).map(x => {
                return x.toFixed(Math.abs(x) > 0.001 ? 4 : 8)
            })
            return [
                {value: xs[0], color: this.hist_colors[values[4]]},
                {value: xs[1], color: this.macd_color},
                {value: xs[2], color: this.signal_color}
            ]
        },
        calc() {
            return {
                props: {
                    fast: { def: 12, text: 'Fast Length' },
                    slow: { def: 26, text: 'Slow Length' },
                    smooth: { def: 9, text: 'Signal EMA' }
                },
                update: `
                    let [macd, signal, hist] =
                        macd(close, fast, slow, smooth)

                    if (hist[0] >= 0) {
                         var color = 0
                         if (hist[0] < hist[1]) color = 1
                    } else {
                        color = 2
                        if (hist[0] > hist[1]) color = 3
                    }

                    return [hist[0], macd[0], signal[0], color]
                `
            }
        }
    },
    // Define internal setting & constants here
    computed: {
        sett() {
            return this.$props.settings
        },
        hist_width() {
            return this.sett.histWidth || 4
        },
        macd_width() {
            return this.sett.macdWidth || 1
        },
        signal_width() {
            return this.sett.signalWidth || 1
        },
        color() {
            return this.sett.defColor || "#42b28a"
        },
        macd_color() {
            return this.sett.macdColor || "#3782f2"
        },
        signal_color() {
            return this.sett.signalColor || "#f48709"
        },
        hist_colors() {
            return [this.sett.histRisingPositive,this.sett.histFallingPositive,this.sett.histFallingNegative,this.sett.histRisingNegative].map((color,index)=>color||this.sett.histColors?.[index]||['#26a69a','#b2dfdb','#ff5252','#ffcdd2'][index])
        }
    }
}
</script>
